module.exports = __webpack_public_path__ + "img/testimonial_top.dd0dc95b.png";